import { ChargeStatus } from '@40seas/entities/charges';
import { EnumColor } from '../enumColor';

export const chargeStatusColorMapping = {
    [ChargeStatus.Pending]: 'default',
    [ChargeStatus.Refunded]: 'default',
    [ChargeStatus.PartiallyRefunded]: 'default',
    [ChargeStatus.Initiated]: 'info',
    [ChargeStatus.Submitted]: 'info',
    [ChargeStatus.InTransit]: 'info',
    [ChargeStatus.Done]: 'success',
    [ChargeStatus.Failed]: 'error',
    [ChargeStatus.Disputed]: 'error',
    [ChargeStatus.Scheduled]: 'info',
    [ChargeStatus.Canceled]: 'error',
    [ChargeStatus.MarkedAsPaid]: 'success',
} as { [key in ChargeStatus]: EnumColor };
